import { gql } from "@apollo/client";

export const VAULT_CREATE_KYB_KYC_SUBMIT = gql`
  mutation VaultCreateKybKycSubmit(
    $gateway: VaultFinancialProvider!
    $rawOrgData: VaultKybCreateInput!
    $rawRepresentativeData: VaultRepresentativeCreateInput!
    $rawBeneficialOwners: [VaultKycCreateInput!]
  ) {
    vaultCreateKybKycSubmit(
      gateway: $gateway
      orgData: $rawOrgData
      representativeData: $rawRepresentativeData
      beneficialOwners: $rawBeneficialOwners
    ) {
      success
      successData {
        beneficialOwners {
          kycId
          userId
        }
        kybData {
          financialAccountId
          kybId
          orgId
          applicationId
        }
        payableOrgNode {
          beneficialOwners {
            kycId
            userId
          }
          kybData {
            financialAccountId
            kybId
            orgId
            applicationId
          }
          representative {
            kycId
            userId
          }
        }
        representative {
          kycId
          userId
        }
      }
    }
  }
`;
